<template>
  <div
    class="c-button flex items-center py-3 text-white"
    :class="[
      icon ? 'justify-start' : 'justify-center',
      secondary ? 'secondary' : '',
      { disabled: !confirmedStatus },
    ]"
    :style="buttonStyle"
    @click="handleClick"
  >
    <div v-if="$slots.icon" class="icon-wrapper ml-5 mr-3 flex justify-center">
      <slot name="icon"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CButton',
  props: {
    icon: Boolean,
    secondary: {
      type: Boolean,
      default: false,
    },
    confirmedStatus: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, String],
      default: 246,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.confirmedStatus) {
        this.$emit('click');
      }
    },
  },
  computed: {
    buttonStyle() {
      const style = {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
      };
      if (this.secondary) return style;

      return {
        ...style,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.c-button {
  cursor: pointer;
  max-width: 246px;
  height: 45px;
  min-height: 45px;
  border-radius: 60px;
  box-shadow: 0px 4px 15px 0 rgba(74, 74, 74, 0.25);
  background-image: linear-gradient(to right, #540deb, #2245ff);
  outline: 0;

  &.secondary {
    position: relative;
    color: #262626;
    box-sizing: border-box;
    background: #fff;
    background-clip: padding-box;
    border: solid 1px #4300d9;
    box-shadow: none;
  }
  &.secondary span {
    background: linear-gradient(270deg, #2245ff 0.85%, #4300d9 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus,
  &:focus-within,
  &:focus-visible,
  &:active {
    transform: translateY(1px);
    background-image: linear-gradient(to right, #3140bd, #4e26a3);
  }
}
.icon-wrapper {
  max-width: 25px;
  min-width: 25px;
}
</style>
